import { Action } from "../actions/types"
import { SparePartsType, SparePartsActionList } from "../actions/sparePartsActions"

const initialValue: Array<SparePartsType> = []

const sparePartsReducer = (state: Array<SparePartsType> = initialValue, action: Action) => {
    switch (action.type) {

        case SparePartsActionList.ADD_SPARE_PARTS:
            return [
                ...state,
                action.data,
            ]

        case SparePartsActionList.UPDATE_SPARE_PARTS:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case SparePartsActionList.FETCH_SPARE_PARTS:
            return action.data

        case SparePartsActionList.DELETE_SPARE_PARTS:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default sparePartsReducer